import { render, staticRenderFns } from "./MortgageContentPage.vue?vue&type=template&id=33608cfd&scoped=true"
import script from "./MortgageContentPage.vue?vue&type=script&lang=js"
export * from "./MortgageContentPage.vue?vue&type=script&lang=js"
import style0 from "./MortgageContentPage.vue?vue&type=style&index=0&id=33608cfd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33608cfd",
  null
  
)

export default component.exports